import PLPState from "../plp_state.js";

$(document).on("mousedown", ".list-title", function (event) {
    $(this).toggleClass("active");
});

$(document).mousedown(function (event) {
    let $target = $(event.target);
    if (
        !$target.closest(".multi-select").length &&
        $(".multi-select").is(":visible")
    ) {
        var visibleMultiSelects = $(".multi-select").filter(function() {
            return $(this).hasClass("active");
        });
        visibleMultiSelects.removeClass("active");
        visibleMultiSelects.trigger("closed");
    }
});

$(document).on("mousedown", ".list .list-item", function (event) {
    event.preventDefault();
    event.stopPropagation();
    var input = $(this).find("input");

    if (input.is(":checked")) {
        input.prop("checked", false);
    } else {
        input.prop("checked", true);
    }
    input.trigger("change");
    
    if (input.data("val") === "all") {

        if (input.is(":checked")) {
            input.closest(".list").find("input").prop("checked", true)

            if ($(".plp-container").length) {
                let plpState = PLPState.getInstance();

                input
                .parents(".list")
                .find('input[data-val="single"]').each(function () {
                    // reset state for sub regions
                    plpState.remove($(this).data("filtertype"), $(this).attr('id'));
                })
            }

        } else {
            input.closest(".list").find("input").prop("checked", false).trigger("change");
            input
                .parents(".list")
                .find('input[data-val="all"][data-tier="1"]')
                .prop("checked", false).trigger("change");
        }
    } else {
        input
            .closest(".list")
            .find('input[data-val="all"]')
            .prop("checked", false).trigger("change");
        input
            .parents(".list")
            .find('input[data-val="all"][data-tier="1"]')
            .prop("checked", false).trigger("change");
        input.closest(".list").find("input").trigger("change");
    }
    var $multiSelect = input.closest(".multi-select");
    var hasChanged = JSON.stringify($multiSelect.data("initial-selected-ids"))
                     !==
                     JSON.stringify(getMultiSelectCheckedIds($multiSelect));
    $multiSelect.data("has-changed", hasChanged);
    updateMultiSelectText($multiSelect);

    return false;
});

$(document).on("mousedown", ".multi-select .top-button", function (event) {
    event.preventDefault();
    event.stopPropagation();
    
    var $element = $(this).closest(".multi-select");
    var isActive = $element.hasClass("active");
    
    $(".select-styled").removeClass("active");
    $(".multi-select").removeClass("active");
    
    if (isActive) {
        $element.removeClass("active");
        $element.trigger("closed");
    } else {
        $element.addClass("active");
        $element.data("has-changed", false);
        $element.data("initial-selected-ids", getMultiSelectCheckedIds($element));
        setTimeout(function () {
            if($('.plp-container .filter-container').length){
                $('.plp-container .filter-container').get(0).scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 200);
    }
});

function updateMultiSelectText($multiSelect) {
    var selectedCount = $multiSelect.find('input[type="checkbox"]:checked[data-val!="all"]').length;
    var multiSelectTitle = $multiSelect.find('.top-button .checkbox-title');
    var selectedTitle = multiSelectTitle.data('selectedTitle');
    var defaultTitle = multiSelectTitle.data('defaultTitle');
    var newTitle = (selectedCount > 0) ? `${selectedTitle} - Selected (${selectedCount})` : defaultTitle;
    multiSelectTitle.text(newTitle);
}

$(document).on("mousedown", ".multi-select .select-button", function (e) {
    e.preventDefault();
    $(this).closest(".multi-select").removeClass("active");
});

var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
        $(mutation.addedNodes).each(function () {
            if ($(this).hasClass('.multi-select')) {
                updateMultiSelectText($(this));
            } else {
                $(this)
                .find(".multi-select")
                .each(function () {
                    updateMultiSelectText($(this));
                });
            }
        });
    });
});

observer.observe(document.body, { childList: true, subtree: true });

// Fix titles for elements that are already on the page
$(".multi-select").each(function () {
    updateMultiSelectText($(this));
});

function getMultiSelectCheckedIds(multiSelectElement) {
    return $(multiSelectElement).find(".list input:checked")
        .map(function() {return this.id})
        .get()
        .sort();
}
